<template>
	<div>
		<!-- <top></top> -->
		<div class="policy">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<!-- <p class="text-sm text-666">首页 - 蓝友介绍</p> -->
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm">法律声明</span></el-breadcrumb-item>
				</el-breadcrumb>
				<!-- <p class="flex align-center text-999 text-sm pointer" @click="back()">
					<i class="el-icon-back"></i>
					<span>返回</span>
				</p> -->
			</div>
			<div class="margin-bottom">
				<p class="titlea text-center text-bold text-white">法律声明</p>
				<div class="bg-white text-left margin-top padding" v-html="body"></div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Top from '@/components/public/top.vue';
	export default {
		components: {
			Top
		},
		name: '',
		data() {
			return {
				body:''
				
			}
		},
		created() {
			Bus.$emit('chosename','home')
			this.getdetail()
		},
		methods: {
			back(){
				this.$router.back()
			},
			getdetail(){
				this.ajax('get', '/api/pc/agreement/getInfo', {
					type:3,
				}, res => {
					// res = res.data
					if(res.status == 200){
						this.body = res.data.content
					}else{
						this.$message.info(res.msg);
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.policy{
		width: 1210px;
		margin: 0 auto;
		.titlea{
			width: 1202px;
			height: 506px;
			font-size: 46px;
			background: url(../../assets/img/articb.png);
			line-height: 506px;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/view/tab/law.vue